import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

const upsertGoal = (clientId: string, url: string) => (params: Record<string, any>) => {
  return authFetch(url, {
    method: 'POST',
    ...httpBodyOptions({ ...params, clientId }),
  });
};

interface MutationParams {
  clientId: string;
  url: string;
}

export const useUpsertGoalMutation = ({ clientId, url }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(upsertGoal(clientId, url), {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.goals(clientId));
    },
  });
};
